import React, { useRef, useState, useEffect } from 'react'
import './Music_play_modal.css'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Slider from '@mui/material/Slider';
import { IDS } from '../../../../utils/IDS';

const Music_play_modal = ({ music, musicList, ...props }) => {

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const timerRef = useRef(null);
    const [chantMode, setChantMode] = useState(false);
    const [selectedMinutes, setSelectedMinutes] = useState(0);

    // ✅ Track current song index
    const [currentIndex, setCurrentIndex] = useState(
        musicList?.findIndex((m) => m.id === music?.id) || 0
    );

    const currentMusic = musicList?.[currentIndex] || music;

    // ✅ Reset and play when song changes
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.load(); // reload new src
            audioRef.current.currentTime = 0;
            setCurrentTime(0);
            setDuration(0);
            setIsPlaying(false);

            // auto play next song
            audioRef.current.play().then(() => {
                setIsPlaying(true);
            }).catch(() => { });
        }
    }, [currentIndex]);

    // ✅ Sync index when music prop changes from outside
    useEffect(() => {
        const index = musicList?.findIndex((m) => m.id === music?.id);
        if (index !== -1) setCurrentIndex(index);
    }, [music]);

    const handlePlayPause = () => {
        if (!isPlaying) {
            audioRef.current?.play();
        } else {
            audioRef.current?.pause();
        }
        setIsPlaying(!isPlaying);
    };

    const handleLoadedMetadata = () => {
        setDuration(audioRef?.current?.duration);
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef?.current?.currentTime);
    };

    const handleSeek = (e, value) => {
        audioRef.current.currentTime = value;
        setCurrentTime(value);
    };

    // ✅ Auto play next song when current ends
    const handleAudioEnded = () => {
        if (chantMode) return; // loop handles it
        handleNext();
    };

    // ✅ Previous song
    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        } else {
            setCurrentIndex(musicList?.length - 1); // loop to last
        }
    };

    // ✅ Next song
    const handleNext = () => {
        if (currentIndex < musicList?.length - 1) {
            setCurrentIndex(currentIndex + 1);
        } else {
            setCurrentIndex(0); // loop to first
        }
    };

    const handleChantToggle = (e) => {
        const checked = e.target.checked;
        setChantMode(checked);
        if (audioRef.current) {
            audioRef.current.loop = checked;
        }
    };

    const handleDurationChange = (e) => {
        const minutes = Number(e.target.value);
        setSelectedMinutes(minutes);
        if (!minutes) return;

        clearTimeout(timerRef.current);

        if (!isPlaying) {
            audioRef.current?.play();
            setIsPlaying(true);
        }

        timerRef.current = setTimeout(() => {
            audioRef.current?.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
            setChantMode(false);
            audioRef.current.loop = false;
        }, minutes * 60 * 1000);
    };

    const handleShareAudio = async () => {
        try {
            const audioUrl = IDS.IMG_URL + currentMusic?.audio;
            if (navigator.share) {
                const response = await fetch(audioUrl);
                const blob = await response.blob();
                const file = new File([blob], `${currentMusic?.name}.mp3`, { type: blob.type });
                navigator.share({ files: [file] });
            }
        } catch (error) {
            console.error("Share cancelled or failed", error);
        }
    };

    // ✅ Format time mm:ss
    const formatTime = (time) => {
        const min = Math.floor(time / 60);
        const sec = Math.floor(time % 60).toString().padStart(2, "0");
        return `${min}:${sec}`;
    };

    return (
        <>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='Music_play_modal'
            >
                {/* ✅ Audio uses currentMusic */}
                <audio
                    ref={audioRef}
                    src={IDS.IMG_URL + currentMusic?.audio}
                    onLoadedMetadata={handleLoadedMetadata}
                    onTimeUpdate={handleTimeUpdate}
                    onEnded={handleAudioEnded}
                />

                <Modal.Body>
                    <div className='row'>
                        <div className='col-md-4 col-8 mx-auto'>
                            <div className='musicicondiv'>
                                <img className='bground' src={process.env.PUBLIC_URL + '/assets/gifs/insight/guru_pravachan/bg_gif.gif'} />
                                <div className='overlaybg'></div>
                                <img className='maharaj' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/maharaj.png'} />
                            </div>
                        </div>

                        <div className='col-md-8'>
                            <div className="playsec">

                                <div className='row'>
                                    <div className='col-6'>
                                        <Form>
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                label="Chant Mode"
                                                checked={chantMode}
                                                onChange={handleChantToggle}
                                            />
                                        </Form>
                                    </div>
                                    <div className='col-6 text-end'>
                                        <div className='flexbtnss'>
                                            <img
                                                className='icons'
                                                src={process.env.PUBLIC_URL + '/assets/images/icons/playshare.png'}
                                                onClick={handleShareAudio}
                                                style={{ cursor: "pointer" }}
                                            />
                                            <img type="button" onClick={props.onHide} className='icons' src={process.env.PUBLIC_URL + '/assets/images/icons/close.png'} />
                                        </div>
                                    </div>
                                </div>

                                <div className='music_desc'>
                                    {/* ✅ Show current song name */}
                                    <p className='musname'>{currentMusic?.name || " "}</p>
                                    <p className='mussubname'>{currentMusic?.Chant_Type?.name || " "}</p>

                                    <Slider
                                        size="small"
                                        value={currentTime}
                                        min={0}
                                        max={duration || 0}
                                        onChange={handleSeek}
                                    />

                                    {/* ✅ Time display */}
                                    <div className='d-flex justify-content-between'>
                                        <small>{formatTime(currentTime)}</small>
                                        <small>{formatTime(duration)}</small>
                                    </div>

                                    <div className='musplayflex'>
                                        {/* ✅ Prev */}
                                        <img
                                            className='nextprev'
                                            style={{ cursor: "pointer" }}
                                            src={process.env.PUBLIC_URL + '/assets/images/icons/step-backward.png'}
                                            onClick={handlePrev}
                                        />

                                        {/* Play/Pause */}
                                        <img
                                            className='playstop'
                                            onClick={handlePlayPause}
                                            src={
                                                isPlaying
                                                    ? process.env.PUBLIC_URL + "/assets/images/icons/musicpause.png"
                                                    : process.env.PUBLIC_URL + "/assets/images/icons/musicplay.png"
                                            }
                                            alt="play/pause"
                                        />

                                        {/* ✅ Next */}
                                        <img
                                            className='nextprev'
                                            style={{ cursor: "pointer" }}
                                            src={process.env.PUBLIC_URL + '/assets/images/icons/step-forward.png'}
                                            onClick={handleNext}
                                        />
                                    </div>
                                </div>

                                <div className='selectduration'>
                                    <Form.Select onChange={handleDurationChange}>
                                        <option>Set Duration</option>
                                        <option value="5">5 Minutes</option>
                                        <option value="15">15 Minutes</option>
                                        <option value="25">25 Minutes</option>
                                        <option value="35">35 Minutes</option>
                                        <option value="45">45 Minutes</option>
                                        <option value="55">55 Minutes</option>
                                        <option value="65">65 Minutes</option>
                                        <option value="75">75 Minutes</option>
                                        <option value="85">85 Minutes</option>
                                    </Form.Select>
                                </div>

                                {/* ✅ Song list */}
                                {/* <div className='song_list mt-3'>
                                    {musicList?.map((item, index) => (
                                        <div
                                            key={item?.id}
                                            className={`song_item d-flex align-items-center p-2 ${index === currentIndex ? "active_song" : ""}`}
                                            onClick={() => setCurrentIndex(index)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <span className='me-2'>{index + 1}.</span>
                                            <span>{item?.name}</span>
                                            {index === currentIndex && isPlaying && (
                                                <span className='ms-auto'>▶</span>
                                            )}
                                        </div>
                                    ))}
                                </div> */}

                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Music_play_modal;